import PropTypes from 'prop-types';
import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useReducer,
} from 'react';
import { contextReducer, InFoViewActions } from './InfoViewReducer';

export const ContextState = {
    loading: false,
    error: '',
    message: '',
};

const InfoViewContext = createContext();
const InfoViewActionsContext = createContext();

export const useInfoViewContext = () => useContext(InfoViewContext);
export const useInfoViewActionsContext = () =>
    useContext(InfoViewActionsContext);

const InfoViewContextProvider = (props) => {
    const [state, dispatch] = useReducer(
        contextReducer,
        ContextState,
        () => ContextState,
    );

    const fetchStart = useCallback(() => {
        dispatch({ type: InFoViewActions.FETCH_STARTS });
    }, []);

    const fetchSuccess = useCallback(() => {
        dispatch({ type: InFoViewActions.FETCH_SUCCESS });
    }, []);

    const fetchError = (error) => {
        dispatch({ type: InFoViewActions.SET_ERROR, payload: error });
    };

    const showMessage = (message) => {
        dispatch({ type: InFoViewActions.SET_MESSAGE, payload: message });
    };

    const clearInfoView = () => {
        dispatch({ type: InFoViewActions.CLEAR_INFOVIEW });
    };

    const values = useMemo(
        () => ({
            fetchStart,
            fetchSuccess,
            fetchError,
            showMessage,
            clearInfoView,
        }),
        [fetchStart, fetchSuccess, fetchError, showMessage, clearInfoView],
    );

    return (
        <InfoViewContext.Provider value={state}>
            <InfoViewActionsContext.Provider value={values}>
                {props.children}
            </InfoViewActionsContext.Provider>
        </InfoViewContext.Provider>
    );
};

export default InfoViewContextProvider;

InfoViewContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
